import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [{
	path: '/',
	component: () => import('../views/Home.vue'),
	children: [
		// ====== 项目管理 ======
		{
			path: 'projects',
			name: 'projects',
			component: () => import('../views/type_assistant/z_project/ProjectHub.vue'),
			meta: { title: '项目管理' }
		}, {
			path: 'project',
			name: 'project',
			component: () => import('../views/type_assistant/z_project/proejct.vue'),
			meta: { title: '系列会管理' }
		}, {
			path: 'projectDetail',
			name: 'projectDetail',
			component: () => import('../views/type_assistant/z_project/ProjectDetail.vue'),
			meta: { title: '项目详情' }
		}, {
			path: 'supplierCenterList',
			name: 'supplierCenterList',
			component: () => import('../views/type_assistant/z_project/backproject1.vue'),
			meta: { title: '结算中心' }
		}, {
			path: 'spendingManage',
			name: 'spendingManage',
			component: () => import('../views/type_assistant/z_spending/SpendingManage.vue'),
			meta: { title: '结算单管理' }
		}, {
			path: 'laborSettlement',
			name: 'laborSettlement',
			component: () => import('../views/type_assistant/z_settlementCenter/LaborSettlement.vue'),
			meta: { title: '劳务结算' }
		}, {
			path: 'singleMeets',
			name: 'singleMeets',
			component: () => import('../views/type_assistant/z_meetlist/singleMeets.vue'),
			meta: { title: '单场会管理' }
		}, {
			path: 'meetinglist',
			name: 'meetinglist',
			component: () => import('../views/type_assistant/z_meetlist/meetlist.vue'),
			meta: { title: '会议列表' }
		},

		// ====== 会议管理（项目内部） ======
		{
			path: 'createmeet',
			name: 'createmeet',
			component: () => import('../views/type_assistant/z_createmeet/createmeet.vue'),
			meta: { title: '创建会议' }
		}, {
			path: 'confmeet',
			name: 'confmeet',
			component: () => import('../views/type_assistant/z_confmeet/confmeet.vue'),
			meta: { title: '确认会议信息' }
		}, {
			path: 'meetdetails',
			name: 'meetdetails',
			component: () => import('../views/type_assistant/z_meetdetails/meetdetails.vue'),
			meta: { title: '会议详情' }
		}, {
			path: 'uploadFile',
			name: 'uploadFile',
			component: () => import('../views/type_assistant/z_upLoadFile/index.vue'),
			meta: { title: '上传文件' }
		},

		// ====== 健康科普管理 ======
		{
			path: 'healthManage',
			name: 'healthManage',
			component: () => import('../views/health/HealthManage.vue'),
			meta: { title: '健康科普管理' }
		},

		// ====== 医生管理（项目内部） ======
		{
			path: 'doctor',
			name: 'doctor',
			component: () => import('../views/type_assistant/z_doctor/doctor.vue'),
			meta: { title: '医生列表' }
		}, {
			path: 'doctorinfo',
			name: 'doctorinfo',
			component: () => import('../views/type_assistant/z_doctorinfo/doctorinfo.vue'),
			meta: { title: '医生详情' }
		}, {
			path: 'reviewdoctor',
			name: 'reviewdoctor',
			component: () => import('../views/type_assistant/z_doctor/reviewdoctor.vue'),
			meta: { title: '待审核医生' }
		}, {
			path: 'creatdoc',
			name: 'creatdoc',
			component: () => import('../views/type_assistant/z_creatdoc/creatdoc.vue'),
			meta: { title: '创建账号' }
		}, {
			path: 'perInfo',
			name: 'perInfo',
			component: () => import('../views/type_assistant/z_creatdoc/perInfo.vue'),
			meta: { title: '创建账号' }
		}, {
			path: 'upInfo',
			name: 'upInfo',
			component: () => import('../views/type_assistant/z_creatdoc/upInfo.vue'),
			meta: { title: '创建账号' }
		}, {
			path: 'selectPro',
			name: 'selectPro',
			component: () => import('../views/type_assistant/z_creatdoc/selectPro.vue'),
			meta: { title: '创建账号' }
		},

		// ====== 权限配置（仅管理员） ======
		{
			path: 'permissionConfig',
			name: 'permissionConfig',
			component: () => import('../views/type_assistant/z_permission/PermissionConfig.vue'),
			meta: { title: '权限配置' }
		},

		// ====== 参数配置（仅管理员） ======
		{
			path: 'configManage',
			name: 'configManage',
			component: () => import('../views/type_assistant/z_config/ConfigManage.vue'),
			meta: { title: '参数配置' }
		},

		// ====== AI 审核配置中心（仅管理员） ======
		{
			path: 'aiRule',
			name: 'aiRule',
			component: () => import('../views/type_assistant/z_aiaudit/AiRuleManage.vue'),
			meta: { title: 'AI 规则库' }
		}, {
			path: 'aiCheckItem',
			name: 'aiCheckItem',
			component: () => import('../views/type_assistant/z_aiaudit/AiCheckItemManage.vue'),
			meta: { title: 'AI 检查项管理' }
		}, {
			path: 'aiDict',
			name: 'aiDict',
			component: () => import('../views/type_assistant/z_aiaudit/AiDictManage.vue'),
			meta: { title: 'AI 参数配置' }
		}, {
			path: 'aiLlm',
			name: 'aiLlm',
			component: () => import('../views/type_assistant/z_aiaudit/AiLlmManage.vue'),
			meta: { title: 'AI 大模型配置' }
		}, {
			path: 'aiAuditTask',
			name: 'aiAuditTask',
			component: () => import('../views/type_assistant/z_aiaudit/AiAuditTask.vue'),
			meta: { title: 'AI 审核任务' }
		},

		// ====== 用户管理 ======
		{
			path: 'userManage',
			name: 'userManage',
			component: () => import('../views/type_assistant/z_user/UserManage.vue'),
			meta: { title: '用户管理' }
		},

		// ====== 结算中心（官员审核） ======
		{
			path: 'settlementCenter',
			name: 'settlementCenter',
			component: () => import('../views/type_official/settlementCenter/index.vue'),
			meta: { title: '结算中心' }
		}, {
			path: 'settlementAudit',
			name: 'settlementAudit',
			component: () => import('../views/type_official/settlementCenter/audit.vue'),
			meta: { title: '供应商结算审核' }
		}, {
			path: 'settlementAuditNew',
			name: 'settlementAuditNew',
			component: () => import('../views/type_official/settlementCenter/SettlementAudit.vue'),
			meta: { title: '供应商结算审核（新）' }
		}, {
			path: 'settleaccount',
			name: 'settleaccount',
			component: () => import('../views/type_official/settleaccount/settleaccount.vue'),
			meta: { title: '项目回款记录' }
		}, {
			path: 'fileUpdataReviewWithOffcial',
			name: 'fileUpdataReviewWithOffcial',
			component: () => import('../views/type_official/settlementCenter/fileUpdataReview.vue'),
			meta: { title: '明细文件' }
		}, {
			path: 'fileListPreviewWithOfficial',
			name: 'fileListPreviewWithOfficial',
			component: () => import('../views/type_official/settlementCenter/fileList.vue'),
			meta: { title: '明细文件' }
		},

		// ====== 供应商结算（助教提交 / 官员查看） ======
		{
			path: 'supplierSettlement',
			name: 'supplierSettlement',
			component: () => import('../views/type_official/supplierSettlement/index.vue'),
			meta: { title: '供应商结算' }
		}, {
			path: 'settlementEdit',
			name: 'settlementEdit',
			component: () => import('../views/type_assistant/z_settlement/SettlementEdit.vue'),
			meta: { title: '供应商结算编辑' }
		}, {
			path: 'fileUpdataReview',
			name: 'fileUpdataReview',
			component: () => import('../views/type_official/fileUpdataReview/index.vue'),
			meta: { title: '供应商结算' }
		}, {
			path: 'fileListPreview',
			name: 'fileListPreview',
			component: () => import('../views/type_official/fileListPreview/index.vue'),
			meta: { title: '明细文件' }
		}, {
			path: 'fileListPreviewnew',
			name: 'fileListPreviewnew',
			component: () => import('../views/type_official/fileListPreview/newindex.vue'),
			meta: { title: '明细文件' }
		}, {
			path: 'viewDetail',
			name: 'viewDetail',
			component: () => import('../views/type_official/fileListPreview/viewdatail.vue'),
			meta: { title: '明细文件' }
		},

		// ====== 我的会议 ======
		{
			path: 'myMeetings',
			name: 'myMeetings',
			component: () => import('@/views/meeting_room/MeetingList.vue'),
			meta: { title: '我的会议' }
		},

		// ====== 签署协议（医生扫码签署） ======
		{
			path: 'agreement',
			name: 'agreement',
			component: () => import('../views/agreement/agreement.vue'),
			meta: { title: '签署劳务协议' }
		},

		// ====== 个人中心 ======
		{
			path: 'my',
			name: 'my',
			component: () => import('../views/my/my.vue'),
			meta: { title: '我的' }
		}, {
			path: 'changeInfo',
			name: 'changeInfo',
			component: () => import('../views/changeInfo/changeInfo.vue'),
			meta: { title: '修改个人信息' }
		}, {
			path: 'changepwd',
			name: 'changepwd',
			component: () => import('../views/changepwd/changepwd.vue'),
			meta: { title: '修改密码' }
		},

		// ====== 以下从 yixiulivepc 合并 ======

		// ====== 医生视角 ======
		{
			path: 'meetlist',
			name: 'meetlist',
			component: () => import('../views/type_doctor/d_meetlist/meetlist.vue'),
			meta: { title: '预定会议' }
		}, {
			path: 'meethistory',
			name: 'meethistory',
			component: () => import('../views/type_doctor/d_meetlist/meethistory.vue'),
			meta: { title: '历史会议' }
		}, {
			path: 'dmeetdetail',
			name: 'dmeetdetail',
			component: () => import('../views/type_doctor/d_meetdetail/meetdetail.vue'),
			meta: { title: '会议详情' }
		}, {
			path: 'laowu',
			name: 'laowu',
			component: () => import('../views/type_doctor/d_laowu/laowu.vue'),
			meta: { title: '劳务' }
		}, {
			path: 'myproject',
			name: 'myproject',
			component: () => import('../views/type_doctor/d_myproject/myproject.vue'),
			meta: { title: '我的项目' }
		},

		// ====== 直播 & 患者信息 ======
		{
			path: 'livePage/:id?',
			name: 'livePage',
			component: () => import('../views/livePage/livePage.vue'),
			meta: { title: '直播页面' }
		}, {
			path: 'patientInfo/:id?',
			name: 'patientInfo',
			component: () => import('../views/patientInfo/patientInfo.vue'),
			meta: { title: '劳务详情' }
		},

		// ====== 官员管理（从 PC 合并） ======
		{
			path: '/official',
			name: 'official',
			component: () => import('@/views/type_official/official.vue'),
			meta: { title: '会议列表' }
		}, {
			path: '/officialMeetingDetail',
			name: 'officialMeetingDetail',
			component: () => import('@/views/type_official/meetingDetail/meetingDetail.vue'),
			meta: { title: '会议详情' }
		}, {
			path: 'officialSingleMeets',
			name: 'officialSingleMeets',
			component: () => import('../views/type_official/o_meetlist/officialSingleMeets.vue'),
			meta: { title: '单场会管理' }
		}, {
			path: 'offocoalProject',
			name: 'offocoalProject',
			component: () => import('../views/type_official/o_project/project.vue'),
			meta: { title: '系列会管理' }
		}, {
			path: 'projectlist',
			name: 'projectlist',
			component: () => import('../views/type_official/o_project/projectlist.vue'),
			meta: { title: '项目列表' }
		}, {
			path: 'officialMeetinglist',
			name: 'officialMeetinglist',
			component: () => import('../views/type_official/o_meetlist/meetlist.vue'),
			meta: { title: '会议列表' }
		}, {
			path: 'officialCreatemeet',
			name: 'officialCreatemeet',
			component: () => import('../views/type_official/o_createmeet/createmeet.vue'),
			meta: { title: '创建会议' }
		}, {
			path: 'batchCreateMeet',
			name: 'batchCreateMeet',
			component: () => import('../views/type_official/o_createmeet/batchCreateMeet.vue'),
			meta: { title: '批量创建会议' }
		}, {
			path: 'batchCreateAssistant',
			name: 'batchCreateAssistant',
			component: () => import('../views/type_official/myAssistant/batchCreateAssistant.vue'),
			meta: { title: '批量创建助教' }
		}, {
			path: 'officialUploadFile',
			name: 'officialUploadFile',
			component: () => import('../views/type_official/officialUploadFile/index.vue'),
			meta: { title: '上传文件' }
		}, {
			path: 'myAssistant',
			name: 'myAssistant',
			component: () => import('../views/type_official/myAssistant/index.vue'),
			meta: { title: '我的助教' }
		}, {
			path: 'projectTask',
			name: 'projectTask',
			component: () => import('../views/type_official/projectTask/index.vue'),
			meta: { title: '项目配额' }
		}, {
			path: 'projectNotice',
			name: 'projectNotice',
			component: () => import('../views/type_official/projectNotice/index.vue'),
			meta: { title: '项目公告' }
		},

		// ====== 助教补充（从 PC 合并） ======
		{
			path: 'notifications',
			name: 'notifications',
			component: () => import('../views/type_assistant/z_notifications/notifications.vue'),
			meta: { title: '会议操作' }
		}, {
			path: 'mapTest',
			name: 'mapTest',
			component: () => import('../views/type_assistant/mapTest.vue'),
			meta: { title: '地图测试' }
		}, {
			path: 'liveUrl',
			name: 'liveUrl',
			component: () => import('../views/type_assistant/z_liveurl/liveUrl.vue'),
			meta: { title: '预览会议链接与二维码' }
		}, {
			path: 'coverupload',
			name: 'coverupload',
			component: () => import('../views/type_assistant/z_coverupload/coverupload.vue'),
			meta: { title: '上传KV海报' }
		}, {
			path: 'template',
			name: 'template',
			component: () => import('../views/type_assistant/z_template/index.vue'),
			meta: { title: '常用模板' }
		}, {
			path: 'option',
			name: 'option',
			component: () => import('../views/type_assistant/z_option/option.vue'),
			meta: { title: '操作' }
		}
	]
},
{
	path: '/meetingRoom',
	name: 'meetingRoom',
	component: () => import('@/views/meeting_room/MeetingRoom.vue'),
	meta: { title: '视频会议室' }
},
{
	path: '/meetingEntry',
	name: 'meetingEntry',
	component: () => import('@/views/meeting_room/EntryForm.vue'),
	meta: { title: '会议入场验证' }
},
{
	path: '/login',
	name: 'login',
	component: () => import('@/views/login/login.vue'),
	meta: { title: '登录' }
},
{
	path: 'forgetpwd',
	name: 'forgetpwd',
	component: () => import('../views/changepwd/forgetpwd.vue'),
	meta: { title: '忘记密码' }
},
{
	path: '/register',
	name: 'register',
	component: () => import('@/views/register/register.vue'),
	meta: { title: '注册' }
},
{
	path: '/ImproveInfo',
	name: 'ImproveInfo',
	component: () => import('@/views/register/ImproveInfo.vue'),
	meta: { title: '完善信息' }
},
{
	path: '/upLoadInfo',
	name: 'upLoadInfo',
	component: () => import('../views/register/UploadInfo.vue'),
	meta: { title: '上传照片' }
},
{
	path: '/setpwd',
	name: 'setpwd',
	component: () => import('@/views/register/setpwd.vue'),
	meta: { title: '设置密码' }
},
{
	path: '/SelectProject',
	name: 'SelectProject',
	component: () => import('@/views/register/SelectProject.vue'),
	meta: { title: '选择参与项目' }
},
{
	path: '/result',
	name: 'result',
	component: () => import('../views/register/result.vue'),
	meta: { title: '' }
},
{
	path: '/:pathMatch(.*)*',
	name: 'NotFound',
	component: () => import('../components/NotFound.vue'),
	meta: { title: '404' }
},
];

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
	linkActiveClass: 'active'
})

router.beforeEach((to, from, next) => {
	console.log("跳转路径" + to.path)

	// ====== 嵌入模式：供应商结算页面通过 URL 传 token ======
	if (to.path === '/supplierSettlement') {
		const urlParams = new URLSearchParams(window.location.search)
		const sign = urlParams.get('sign')
		if (sign) {
			let tokenObj= JSON.stringify({token: sign});
			localStorage.setItem('token', tokenObj);
			sessionStorage.setItem('embed_mode', true);
		}
	}

	// ====== 设置页面标题 ======
	document.documentElement.scrollTop = 0
	if (to.meta.title) {
		document.title = `万木智会-${to.meta.title}`;
	} else {
		document.title = `万木智会`;
	}

	// ====== Token 校验（前端路由鉴权） ======
	// 白名单页面：不需要 token 即可访问
	const whiteList = ['login', 'register', 'forgetpwd', 'ImproveInfo', 'upLoadInfo', 'setpwd', 'SelectProject', 'result', 'NotFound'];
	if (whiteList.includes(to.name)) {
		next();
		return;
	}

	// 检查 token 是否存在
	const tokenStr = localStorage.getItem('token') || sessionStorage.getItem('token');
	if (!tokenStr) {
		console.warn('未检测到登录信息，跳转登录页');
		next({ name: 'login' });
		return;
	}

	// token 存在，放行
	next();
});

export default router
